import React from 'react';
import { Book, Building2, DollarSign, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';

export function ResourcesHero() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-blue-50 to-purple-50 py-24">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full border-2 border-blue-500/30"
              style={{
                width: `${(i + 1) * 20}%`,
                height: `${(i + 1) * 20}%`,
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                animation: `ping ${3 + i}s cubic-bezier(0, 0, 0.2, 1) infinite`
              }}
            />
          ))}
        </div>
      </div>

      {/* Floating Icons */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-1/4 left-1/4"
          animate={{
            y: [0, -20, 0],
            rotate: [0, 10, -10, 0],
          }}
          transition={{ duration: 5, repeat: Infinity }}
        >
          <Book className="w-12 h-12 text-purple-500/30" />
        </motion.div>
        <motion.div
          className="absolute top-1/3 right-1/4"
          animate={{
            y: [0, -20, 0],
            rotate: [0, -10, 10, 0],
          }}
          transition={{ duration: 5, repeat: Infinity, delay: 0.5 }}
        >
          <Building2 className="w-16 h-16 text-blue-500/30" />
        </motion.div>
        <motion.div
          className="absolute bottom-1/4 left-1/3"
          animate={{
            y: [0, -20, 0],
            rotate: [0, 10, -10, 0],
          }}
          transition={{ duration: 5, repeat: Infinity, delay: 1 }}
        >
          <DollarSign className="w-14 h-14 text-green-500/30" />
        </motion.div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-900 sm:text-5xl lg:text-6xl tracking-tight mb-6"
          >
            Crypto
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {' '}Resources
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="max-w-2xl mx-auto text-xl text-gray-600 leading-relaxed"
          >
            Discover the best platforms, tools, and learning resources in the cryptocurrency ecosystem.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto"
          >
            {[
              { icon: Building2, label: 'Security Tokens', value: '10+ Platforms' },
              { icon: DollarSign, label: 'Loan Platforms', value: '5+ Services' },
              { icon: Book, label: 'Learning Resources', value: '1000+ Articles' }
            ].map((stat, index) => (
              <div key={index} className="bg-white/80 backdrop-blur rounded-2xl p-6 shadow-lg border border-gray-100">
                <div className="flex justify-center mb-4">
                  <stat.icon className="w-8 h-8 text-blue-500" />
                </div>
                <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                <p className="text-sm text-gray-500 mt-2">{stat.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
}